import axios from 'axios';

const kpn = axios.create({
  baseURL: process.env.VUE_APP_KPN_API_URI
});

export default kpn;
